import { render, staticRenderFns } from "./TableChartComponent.vue?vue&type=template&id=9489cc0c&scoped=true"
import script from "./TableChartComponent.vue?vue&type=script&lang=js"
export * from "./TableChartComponent.vue?vue&type=script&lang=js"
import style0 from "./TableChartComponent.vue?vue&type=style&index=0&id=9489cc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9489cc0c",
  null
  
)

export default component.exports